export default {"src":"/_next/static/media/Learn_more.0d031023.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};